<template>
  <v-app>
    <v-app-bar
      v-if="viewPage === 'smartlinkPage'"
      :elevation="0"
      color="background"
    >
      <TopBar v-if="isRAOS" />
      <AppBar v-if="!isRAOS" />
    </v-app-bar>
    <v-main
      :class="
        viewPage !== 'smartlinkPage' ? 'login-styles__demo' : 'home-styles'
      "
    >
    <!-- <v-main
      :class="
        viewPage !== 'smartlinkPage' ? CSSIMAGE[projectName] : 'home-styles'
      "
    > -->
      <router-view />
      <v-sheet v-if="viewPage === 'smartlinkPage' && !isRAOS">
        <DrawerBar />
      </v-sheet>
    </v-main>
    <div>
      <SnackBarNotif />
      <Snack_Bar />
    </div>
    <!-- <div v-if="viewPage === 'smartlinkPage' && !isNacozari && !isRAOS"> -->
    <div v-if="false">
      <FloatingButton />
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import router from "./router";
import { useStore } from "vuex";
import axios from "axios";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import { showConsoleError } from "@/functions/errors";
import { TOKEN } from "@/constants/labels";
// COMPONENTS
import AppBar from "@/components/SmartLink/bars/AppBar.vue";
import SnackBarNotif from "@/components/PrincipalComponents/SnackBarNotif.vue";
import Snack_Bar from "@/components/PrincipalComponents/Snack_Bar.vue";
import DrawerBar from "@/components/SmartLink/bars/DrawerBar.vue";
import FloatingButton from "@/components/PrincipalComponents/FloatingButton.vue";

// CONSTANTS
import { APIS_TOPOLOGY, TIMEOUTTIME } from "./constants/apis";
import { LABELS } from "@/constants/labels";
import TopBar from "./components/RAOS/Bars/TopBar.vue";
const projectName = computed(() => store.state.projectName);
const isRAOS = computed(() => projectName.value === "SmartLinkRAOS");
// const isCananea = computed(() => projectName.value === "SmartLinkCananea");


//==================================================//
//==================== VARIABLES ===================//
//==================================================//

/**
 * Vue / Vuetify
 */
const store = useStore();
const viewPage = computed(() => store.state.appBarPage);

onMounted(async () => {
  const pageStatus = ref(1);


  await axios
    .get(APIS_TOPOLOGY.value.getAllTopoData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(() => {
      pageStatus.value = 1;
    })
    .catch(function (error) {
      pageStatus.value = 0;
      store.commit("showSnackBar", {
        type: LABELS.error,
        msg: t("snackbar.errorApis"),
        valor: true,
      });
      showConsoleError(error);
    });

  if (pageStatus.value === 0) {
    localStorage.removeItem("user");
    router.push("/maintenance");
    store.commit("setAppBarPage", "maintenancePage");
  } else {
    router.push(`/login`)
    store.commit('setAppBarPage','loginPage');
  }
});
</script>

<style>
:root {
  overflow-y: visible;
}

* {
  font-family: "Poppins", sans-serif;
}

.home-styles {
  background-color: rgb(var(--v-theme-background)) !important;
  min-width: 500px !important;
}

.login-styles__local {
  padding-left: 0px !important;
  background-image: url("@/assets/Images/cananeaMina2.jpg");
  background-position: 0% 50%;
  height: 100dvh;
}

.login-styles__cananea {
  padding-left: 0px !important;
  background-image: url("@/assets/Images/cananeaMina2.jpg");
  background-position: 0% 50%;
  height: 100dvh;
}

.login-styles__collahuasi {
  padding-left: 0px !important;
  background-image: url("@/assets/Images/collahuasiMina.jpg");
  background-position: 0% 50%;
  height: 100dvh;
}

.login-styles__demo {
  padding-left: 0px !important;
  background: linear-gradient(-45deg, #191970, #333, #23a6d5);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
  height: 100dvh;
}

.titlePages {
  font-family: "Poppins", sans-serif;
  font-size: 35px;
  text-shadow: 2px 3px 3px rgba(0, 0, 0, 0.2);
  margin-top: 24px;
  margin-left: 16px;
  color: rgb(var(--v-theme-colorText));
}

.v-application__wrap {
  min-height: 100dvh !important;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
